import { useTranslation } from 'react-i18next'
import { DashboardCard } from './components'
import PropTypes from 'prop-types'

export const DashboardCards = (props) => {
  const { data } = props
  const { t } = useTranslation()
  return (
    <div className='grid sm:grid-cols-2 md:grid-cols-3 gap-4 lg:grid-cols-6'>
      <DashboardCard
        title={t('dashboard.card.people.title')}
        subtitle={t('dashboard.card.people.subtitle')}
        value={data?.total_people ?? 0}
        tooltipTitle={t('dashboard.card.people.tooltipTitle')}
        tooltipDescription={t('dashboard.card.people.tooltipDescription')}
      />
      <DashboardCard
        title={t('dashboard.card.activePeople.title')}
        subtitle={t('dashboard.card.activePeople.subtitle')}
        value={data?.active_people ?? 0}
        tooltipTitle={t('dashboard.card.activePeople.tooltipTitle')}
        tooltipDescription={t(
          'dashboard.card.activePeople.tooltipDescription'
        )}
      />
      <DashboardCard
        title={t('dashboard.card.unlinkPeople.title')}
        subtitle={t('dashboard.card.unlinkPeople.subtitle')}
        value={data?.unlinked_employees ?? 0}
        tooltipTitle={t('dashboard.card.unlinkPeople.tooltipTitle')}
        tooltipDescription={t(
          'dashboard.card.unlinkPeople.tooltipDescription'
        )}
      />

      <DashboardCard
        title={t('dashboard.card.activeContractors.title')}
        subtitle={t('dashboard.card.activeContractors.subtitle')}
        value={data?.active_companies ?? 0}
        tooltipTitle={t('dashboard.card.activeContractors.tooltipTitle')}
        tooltipDescription={t(
          'dashboard.card.activeContractors.tooltipDescription'
        )}
      />

      <DashboardCard
          title={t('dashboard.card.activeContracts.title')}
          subtitle={t('dashboard.card.activeContracts.subtitle')}
          value={data?.active_contracts ?? 0}
          tooltipTitle={t('dashboard.card.activeContracts.tooltipTitle')}
          tooltipDescription={t(
            'dashboard.card.activeContracts.tooltipDescription'
          )}
        />
  
      <DashboardCard
        title={t('dashboard.card.assets.title')}
        subtitle={t('dashboard.card.assets.subtitle')}
        value={data?.total_assets ?? 0}
        tooltipTitle={t('dashboard.card.assets.tooltipTitle')}
        tooltipDescription={t('dashboard.card.assets.tooltipDescription')}
      />
    </div>)
}

DashboardCards.propTypes = {
  data: PropTypes.shape({
    total_assets: PropTypes.number,
    active_companies: PropTypes.number,
    active_contracts: PropTypes.number,
    active_people: PropTypes.number,
    total_people: PropTypes.number,
    unlinked_employees: PropTypes.number
  })
}
